import ptBr from './pt-br'

export const dictionary = {
  pt_BR: ptBr
}
